"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _IconCheckMark = _interopRequireDefault(require("@instructure/ui-icons/lib/Solid/IconCheckMark"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _class, _class2, _temp;

var styles = {
  componentId: 'yyQPt',
  template: function template(theme) {
    return "\n\n.yyQPt_bGBk{align-items:flex-start;display:flex}\n\n.yyQPt_cSXm{-webkit-margin-end:".concat(theme.marginRight || 'inherit', ";-webkit-margin-start:0;align-items:center;background:").concat(theme.background || 'inherit', ";border:").concat(theme.borderWidth || 'inherit', " solid ").concat(theme.borderColor || 'inherit', ";border-radius:").concat(theme.borderRadius || 'inherit', ";box-sizing:border-box;color:").concat(theme.color || 'inherit', ";display:flex;flex-shrink:0;justify-content:center;margin-inline-end:").concat(theme.marginRight || 'inherit', ";margin-inline-start:0;padding:").concat(theme.padding || 'inherit', ";position:relative;transition:all 0.2s}\n\n[dir=ltr] .yyQPt_cSXm{margin-left:0;margin-right:").concat(theme.marginRight || 'inherit', "}\n\n[dir=rtl] .yyQPt_cSXm{margin-left:").concat(theme.marginRight || 'inherit', ";margin-right:0}\n\n.yyQPt_cSXm:before{border:").concat(theme.focusBorderWidth || 'inherit', " ").concat(theme.focusBorderStyle || 'inherit', " ").concat(theme.focusBorderColor || 'inherit', ";border-radius:calc(").concat(theme.borderRadius || 'inherit', "*1.5);bottom:-0.3125rem;box-sizing:border-box;content:\"\";left:-0.3125rem;opacity:0;pointer-events:none;position:absolute;right:-0.3125rem;top:-0.3125rem;transform:scale(0.75);transition:all 0.2s}\n\n.yyQPt_blJt{color:").concat(theme.labelColor || 'inherit', ";flex:1 1 auto;font-family:").concat(theme.labelFontFamily || 'inherit', ";font-weight:").concat(theme.labelFontWeight || 'inherit', ";line-height:").concat(theme.labelLineHeight || 'inherit', ";min-width:0.0625rem}\n\n.yyQPt_doqw .yyQPt_blJt{font-size:").concat(theme.labelFontSizeSmall || 'inherit', "}\n\n.yyQPt_doqw .yyQPt_cSXm{font-size:").concat(theme.iconSizeSmall || 'inherit', ";height:").concat(theme.facadeSizeSmall || 'inherit', ";width:").concat(theme.facadeSizeSmall || 'inherit', "}\n\n.yyQPt_ycrn .yyQPt_blJt{font-size:").concat(theme.labelFontSizeMedium || 'inherit', "}\n\n.yyQPt_ycrn .yyQPt_cSXm{font-size:").concat(theme.iconSizeMedium || 'inherit', ";height:").concat(theme.facadeSizeMedium || 'inherit', ";width:").concat(theme.facadeSizeMedium || 'inherit', "}\n\n.yyQPt_cMDj .yyQPt_blJt{font-size:").concat(theme.labelFontSizeLarge || 'inherit', "}\n\n.yyQPt_cMDj .yyQPt_cSXm{font-size:").concat(theme.iconSizeLarge || 'inherit', ";height:").concat(theme.facadeSizeLarge || 'inherit', ";width:").concat(theme.facadeSizeLarge || 'inherit', "}\n\n.yyQPt_cjfS .yyQPt_cSXm{background:").concat(theme.checkedBackground || 'inherit', ";border-color:").concat(theme.checkedBorderColor || 'inherit', "}\n\n.yyQPt_cjfS .yyQPt_blJt{color:").concat(theme.checkedLabelColor || 'inherit', "}\n\n.yyQPt_cVYB .yyQPt_cSXm:before{opacity:1;transform:scale(1)}\n\n.yyQPt_Ffcq .yyQPt_cSXm{border-color:").concat(theme.hoverBorderColor || 'inherit', "}");
  },
  'root': 'yyQPt_bGBk',
  'facade': 'yyQPt_cSXm',
  'label': 'yyQPt_blJt',
  'small': 'yyQPt_doqw',
  'medium': 'yyQPt_ycrn',
  'large': 'yyQPt_cMDj',
  'checked': 'yyQPt_cjfS',
  'focused': 'yyQPt_cVYB',
  'hovered': 'yyQPt_Ffcq'
};

var _ref =
/*#__PURE__*/
_react.default.createElement(_SVGIcon.default, {
  viewBox: "0 0 1920 1920",
  inline: false
}, _react.default.createElement("rect", {
  x: "140",
  y: "820",
  width: "1640",
  height: "280"
}));

var _ref2 =
/*#__PURE__*/
_react.default.createElement(_IconCheckMark.default, {
  inline: false
});

var CheckboxFacade = (
/**
---
parent: Checkbox
---
**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CheckboxFacade, _Component);

  function CheckboxFacade() {
    (0, _classCallCheck2.default)(this, CheckboxFacade);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CheckboxFacade).apply(this, arguments));
  }

  (0, _createClass2.default)(CheckboxFacade, [{
    key: "renderIcon",
    value: function renderIcon() {
      if (this.props.indeterminate) {
        return _ref;
      } else if (this.props.checked) {
        return _ref2;
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var _this$props = this.props,
          size = _this$props.size,
          checked = _this$props.checked,
          focused = _this$props.focused,
          hovered = _this$props.hovered,
          indeterminate = _this$props.indeterminate;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles.checked, checked || indeterminate), (0, _defineProperty2.default)(_classes, styles.focused, focused), (0, _defineProperty2.default)(_classes, styles.hovered, hovered), (0, _defineProperty2.default)(_classes, styles[size], true), _classes);
      return _react.default.createElement("span", {
        className: (0, _classnames.default)(classes)
      }, _react.default.createElement("span", {
        className: styles.facade,
        "aria-hidden": "true"
      }, this.renderIcon()), _react.default.createElement("span", {
        className: styles.label
      }, this.props.children));
    }
  }]);
  CheckboxFacade.displayName = "CheckboxFacade";
  return CheckboxFacade;
}(_react.Component), _class2.propTypes = {
  children: _propTypes.default.node.isRequired,
  checked: _propTypes.default.bool,
  focused: _propTypes.default.bool,
  hovered: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
  * Visual state showing that child checkboxes are a combination of checked and unchecked
  */
  indeterminate: _propTypes.default.bool
}, _class2.defaultProps = {
  checked: false,
  focused: false,
  hovered: false,
  size: 'medium',
  indeterminate: false
}, _temp)) || _class);
exports.default = CheckboxFacade;